import Skeleton from "react-loading-skeleton";
import styles from "./index.module.css";
import { ClipLoader } from "react-spinners";

export default function TimelineSkeleton({loading = true }) {
  const skeletonItems = Array.from({ length: 10 });
  return (
    <div className={styles.timeline}>
      {skeletonItems.map((_, index) => (
            <div className={styles["timeline-item"]} key={index}>
                    <div className={styles["timeline-left"]}>
                        <ClipLoader color="" className={styles["timeline-icon"]}/>
                    </div>
                    <div className={`${styles["timeline-content"]}`}>
                        <Skeleton className={`${styles["timeline-line"]}`}/>
                        <Skeleton className={`${styles["timeline-line"]} ${styles["timeline-small"]}`}/>
                        <Skeleton className={`${styles["timeline-line"]} ${styles["timeline-small"]}`}/>
                    </div>
                </div>
          ))}
    </div>
  );
}